import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M23.25 7.311 12.53 18.03a.749.749 0 0 1-1.06 0L.75 7.311"
	})
});
export { SvgArrowDown1 as ReactComponent };
